import React from "react";
import { StyledContentParentWrapperDesktop, StyledHowItWorkContent } from "./styledHowItWork";
import ContentCardBlock from "./ContentCardBlock";
import { LazyLoadImage } from "react-lazy-load-image-component";
import line from "../../../assets/images/home-page/howItWork/line.svg";
import { StyledButton } from "../../styles/styledButton";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { HookResponsive } from "../../elements/customHooks/HookResponsive";

const ContentParentDesktop = () => {

  const howItWorkItemLeftAnimation = {
    hidden: {
      x: -50,
      opacity: 0
    },
    visible: {
      x: 0,
      opacity: 1,
      transition: { delay: 0.2 }
    }
  };

  const howItWorkItemRightAnimation = {
    hidden: {
      x: 50,
      opacity: 0
    },
    visible: {
      x: 0,
      opacity: 1,
      transition: { delay: 0.2 }
    }
  };

  return (
    <StyledContentParentWrapperDesktop
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: 0.2 }}
    >
      <div className="right-block">
        <StyledHowItWorkContent
          variants={HookResponsive() ? howItWorkItemRightAnimation : null}
        >
          <div className="circle-decoration-block-right-block">
            <div className="circle-decoration-element" />
          </div>
          <ContentCardBlock
            link="/select-online-chat-service-provider"
            manualKey="selectOnlineChatServiceProvider"
            index="1"
            text="Select the online chat service provided by our company. Register in the system."
          />
        </StyledHowItWorkContent>
        <StyledHowItWorkContent
          variants={HookResponsive() ? howItWorkItemRightAnimation : null}
        >
          <div className="circle-decoration-block-right-block">
            <div className="circle-decoration-element" />
          </div>
          <ContentCardBlock
            link="/add-all-necessary-social-networks"
            manualKey="addAllNecessarySocialNetworks"
            index="3"
            text="Add all the necessary social networks for communication and create templates for questions and contact with customers."
          />
        </StyledHowItWorkContent>
        <StyledHowItWorkContent
          vvariants={HookResponsive() ? howItWorkItemRightAnimation : null}
        >
          <div className="circle-decoration-block-right-block">
            <div className="circle-decoration-element" />
          </div>
          <ContentCardBlock
            link="/contact-with-customers-profitable"
            manualKey="contactWithCustomersProfitable"
            index="5"
            text="Contact with customers in the most profitable, efficient and convenient way, thereby increasing the conversion of your project."
          />
        </StyledHowItWorkContent>
      </div>
      <LazyLoadImage
        src={line}
        className="center-block"
        width="100%"
        height="100%"
        visibleByDefault={line}
      />
      <div className="left-block">
        <StyledHowItWorkContent
          variants={HookResponsive() ? howItWorkItemLeftAnimation : null}
        >
          <div className="circle-decoration-block-left-block">
            <div className="circle-decoration-element" />
          </div>
          <ContentCardBlock
            index="2"
            link="/add-online-chat-script"
            manualKey="addOnlineChatScript"
            text="Add the chat code snippet to your site to connect the project. Customize the color, shape, location of the chat on the site, the number of managers, etc."
          />
        </StyledHowItWorkContent>
        <StyledHowItWorkContent
          variants={HookResponsive() ? howItWorkItemLeftAnimation : null}
        >
          <div className="circle-decoration-block-left-block">
            <div className="circle-decoration-element" />
          </div>
          <ContentCardBlock
            link="/create-account-group-managers"
            manualKey="createAccountGroupManagers"
            index="4"
            text="Create an account group for managers."
          />
        </StyledHowItWorkContent>
        <motion.div
          variants={HookResponsive() ? howItWorkItemLeftAnimation : null}
          className="try-subscription-block"
        >
          <StyledButton
            color="main"
            as={NavLink}
            to="/tariff-and-subscription"
            size="18"
            className="try-subscription-action"
          >
            Try a free subscription!
          </StyledButton>
          <div className="circle-decoration-try-subscription-block">
            <div className="circle-decoration-element" />
          </div>
        </motion.div>
      </div>
    </StyledContentParentWrapperDesktop>
  );
};

export default ContentParentDesktop;